import { connect } from "react-redux";
import Account from "./Account";

const mapStateToProps = (state, ownProps) => {
  return {
    tabIndex: state.route.accountTabIndex,
    loading: state.ui.loadingAccounts
  };
};

const AccountContainer = connect(mapStateToProps)(Account);

export default AccountContainer;



// WEBPACK FOOTER //
// ./src/AccountContainer.js